export default class DataSource {
  constructor(vue, name, code, dataSourceValue, dataSourceField) { 
    this.vue = vue
    this.name = name
    this.code = code
    this.dataSourceValue = dataSourceValue
    this.dataSourceField = dataSourceField
    this.searchValue = null
    this.callActionTimeoutHandler = null
    this.callActionTimeoutTime =  350
    this.dataSourceRepository = undefined
  }
  getItems() {
    if (!this.dataSourceRepository) {
      return []
    }

    const data = this.dataSourceRepository.getData()
    if (!data || Object.keys(data) === 0) {
      return []
    }

    return data[this.dataSourceField] || []
  }

  async refresh() {
    if (!this.dataSourceRepository) {
      return
    }
    await this.dataSourceRepository.refresh()
  }

  onAutocompleteCreated(value) {
    if (!value || !this.dataSourceRepository) {
      return
    }

    this.dataSourceRepository.callAction('autocomplete-get-by-id', {
      code: this.value
    })
  }

  onAutocompleteInput(searchValue) {
    this.searchValue = searchValue
    if (!searchValue || !this.dataSourceRepository) {
      return
    }
    clearTimeout(this.callActionTimeoutHandler)
    this.callActionTimeoutHandler = setTimeout(() => {
      this.dataSourceRepository.callAction('autocomplete-on-input', {
        context: searchValue
      })
    }, this.callActionTimeoutTime)
  }

  async initialize () {
    this.dataSourceRepository = await this.vue.$dataSourceCore.CreateDataSource(this.vue, this.dataSourceValue)
    if (!this.dataSourceRepository) {
      console.warn(`${this.vue.$t('vuetifyWidgets.dr-data-widget.dataSource')} '${this.dataSourceValue}' ${this.vue.$t('vuetifyWidgets.dr-data-widget.notExist')}`)
    }
  }
}